import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import './testimonial-card.less';
import { SVGIcon, optimizeContentfulImageUrl } from 'common/components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export default function TestimonialCard({ slide, handleTrack }) {
  const className = useClassName('LPTestimonialCard');
  return (
    <a
      onClick={handleTrack}
      href={slide.fields.sourceLink}
      target="_blank"
      rel="noopener noreferrer"
      className={className('slide')}>
      {typeof slide?.fields?.stars !== 'undefined' && (
        <div className={className('slide__stars')}>
          {new Array(slide.fields.stars).fill(0).map((star, index) => (
            <SVGIcon key={index} name="golden-star" />
          ))}
        </div>
      )}
      <div className={className('slide__content')}>
        <h3 className={className('slide__content__title')}>
          {slide.fields.title}
        </h3>
        <div className={className('slide__content__body')}>
          {documentToReactComponents(slide.fields.body)}
        </div>
      </div>
      <p className={className('slide__author')}>
        <span>{slide.fields.info}</span>
        {slide.fields.sourceIcon?.fields?.file?.url && (
          <img
            src={optimizeContentfulImageUrl(
              slide.fields.sourceIcon.fields.file.url,
              slide.fields.sourceIcon.fields.file.contentType
            )}
            alt={slide.fields.sourceIcon.fields.description}
          />
        )}
      </p>
    </a>
  );
}

TestimonialCard.propTypes = {
  slide: PropTypes.object.isRequired,
  handleTrack: PropTypes.func,
};

TestimonialCard.defaultProps = {
  handleTrack: () => {},
};
